import type { SingleRecordResponse } from '@stakeholderlabs/types'
import { useApiGet } from '~/composables/api/useBaseFetch'
import type { Config } from '~/types/models'

export const useConfigApi = () => {
  const fetch = () => {
    return useApiGet<SingleRecordResponse<Config.Model>>('/config')
  }

  return {
    fetch,
  }
}
